import { AccountRole } from '../enum/account-role.enum'

export class LoggedUser {
  name!: string
  email!: string
  role!: AccountRole[]

  constructor(init?: Partial<LoggedUser>) {
    Object.assign(this, init)
  }
}
